import { useRef, useEffect } from 'react'

export function useEventListener<E extends keyof WindowEventMap>(
  e: E,
  handler: (e: WindowEventMap[E]) => void,
) {
  const handlerRef = useRef(handler)

  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    const run = (e: WindowEventMap[E]) => {
      handlerRef.current(e)
    }
    window.addEventListener(e, run)
    return () => {
      window.removeEventListener(e, run)
    }
  }, [e])
}
